import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/kit";
import { Skeleton } from "@/components/ui/skeleton";
import { IDCard } from "@/components/IDCard";

export default function IDCards() {
  const { user } = useAuth();
  const isEmployee = user?.role === "employee";

  const { data: allEmployees = [], isLoading } = useQuery({
    queryKey: ["employees"],
    queryFn: async () => (await api.get("/employees")).data,
  });

  const employees = isEmployee
    ? allEmployees.filter((e) => e.employee_id === user?.employee_id)
    : allEmployees;

  return (
    <div data-testid="id-cards-page">
      <PageHeader
        title={isEmployee ? "My ID Card" : "Employee ID Cards"}
        subtitle={isEmployee ? "Your official VNS Vinayaka ID card — print or download" : "Modern VNS-branded cards — print or download as an image"}
      />

      {isLoading ? (
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {[1, 2].map((i) => <Skeleton key={i} className="h-[560px] rounded-2xl" />)}
        </div>
      ) : employees.length === 0 ? (
        <p className="py-16 text-center text-slate-400">
          {isEmployee ? "Your ID card isn't ready yet. Please contact your Head." : "No employees found. Add employees in Employee Master first."}
        </p>
      ) : (
        <div className={isEmployee ? "flex justify-center" : "grid grid-cols-1 gap-y-12 xl:grid-cols-2 place-items-center"}>
          {employees.map((e) => (
            <div key={e.employee_id} className="w-full overflow-x-auto flex justify-center">
              <IDCard employee={e} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
